import { render, staticRenderFns } from "./OptionListBuilder.vue?vue&type=template&id=85189d50&scoped=true&"
import script from "./OptionListBuilder.vue?vue&type=script&lang=js&"
export * from "./OptionListBuilder.vue?vue&type=script&lang=js&"
import style0 from "./OptionListBuilder.vue?vue&type=style&index=0&id=85189d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85189d50",
  null
  
)

export default component.exports